import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation, Trans } from 'react-i18next';
import LanguageSwitcher from '../../Component/LanguageSwitcher';

const EmployeePF = () => {
    const { t } = useTranslation('EmployeePF');

    useEffect(() => {
        document.title = t('title');
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', t('metaDescription'));
        }
    }, [t]);

    return (
        <div>
            <header className="d-flex justify-content-end align-items-center p-3 border-bottom">
                <LanguageSwitcher />
            </header>

            <div className="webview">
                <Container>
                    <Row>
                        <Col xs={12}>
                            <Trans i18nKey="introPara1" ns="EmployeePF" components={[<strong key="0" />, <strong key="1" />, <strong key="2" />]} />
                            <br /><br />
                            <Trans
                                i18nKey="introPara2"
                                ns="EmployeePF"
                                components={[
                                    <a
                                        key="0"
                                        href="https://www.goodreturns.in/news/2019/03/06/important-points-you-need-know-about-your-epf-867285.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />
                            <br /><br />
                            <Trans
                                i18nKey="introPara3"
                                ns="EmployeePF"
                                components={[
                                    <a
                                        key="0"
                                        href="https://www.goodreturns.in/personal-finance/planning/2014/11/how-check-epf-or-provident-fund-balance-with-uan-number-321768.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />

                            <h2><Trans i18nKey="aboutHeader" ns="EmployeePF" /></h2>
                            <Trans
                                i18nKey="aboutPara1"
                                ns="EmployeePF"
                                components={[
                                    <a key="0" href="https://www.goodreturns.in/classroom/4-ways-to-check-epf-balance-1162783.html" />, // Placeholder or update link if needed
                                    <strong key="1" />,
                                    <a key="2" href="https://www.goodreturns.in/saving-schemes.html" target="_blank" rel="noopener noreferrer" />
                                ]}
                            />
                            <br /><br />
                            <Trans i18nKey="aboutPara2" ns="EmployeePF" />
                            <br /><br />
                            <Trans i18nKey="aboutPara3" ns="EmployeePF" />
                            <br /><br />
                            <Trans
                                i18nKey="aboutPara4"
                                ns="EmployeePF"
                                components={[<strong key="0" />]}
                            />
                            <br /><br />
                            <Trans i18nKey="aboutPara5" ns="EmployeePF" />
                            <br /><br />
                            <Trans
                                i18nKey="aboutPara6"
                                ns="EmployeePF"
                                components={[<strong key="0" />]}
                            />

                            <h2><Trans i18nKey="whatIsHeader" ns="EmployeePF" /></h2>
                            <Trans i18nKey="whatIsPara1" ns="EmployeePF" components={[<strong key="0" />]} />
                            <br /><br />
                            <Trans i18nKey="whatIsPara2" ns="EmployeePF" />
                            <br /><br />
                            <Trans i18nKey="whatIsPara3" ns="EmployeePF" />
                            <br /><br />
                            <Trans i18nKey="whatIsPara4" ns="EmployeePF" />
                            <br /><br />
                            <Trans i18nKey="whatIsPara5" ns="EmployeePF" />
                            <br /><br />
                            <Trans i18nKey="whatIsPara6" ns="EmployeePF" />

                            <h2><Trans i18nKey="eligibilityHeader" ns="EmployeePF" /></h2>
                            <Trans i18nKey="eligibilityPara1" ns="EmployeePF" components={[<strong key="0" />]} />
                            <ul>
                                <li><Trans i18nKey="eligibilityLi1" ns="EmployeePF" /></li>
                                <li><Trans i18nKey="eligibilityLi2" ns="EmployeePF" /></li>
                                <li><Trans i18nKey="eligibilityLi3" ns="EmployeePF" /></li>
                                <li><Trans i18nKey="eligibilityLi4" ns="EmployeePF" /></li>
                                <li><Trans i18nKey="eligibilityLi5" ns="EmployeePF" /></li>
                            </ul>
                            <Trans
                                i18nKey="eligibilityNote"
                                ns="EmployeePF"
                                components={[<strong key="0" />]}
                            />

                            <h2><Trans i18nKey="interestHeader" ns="EmployeePF" /></h2>
                            <ul>
                                {[...Array(11)].map((_, i) => (
                                    <li key={i}>
                                        <Trans i18nKey={`interestLi${i + 1}`} ns="EmployeePF" />
                                    </li>
                                ))}
                            </ul>
                            <Trans i18nKey="interestPara1" ns="EmployeePF" />
                            <br /><br />
                            <Trans i18nKey="interestPara2" ns="EmployeePF" />

                            <h2><Trans i18nKey="benefitsHeader" ns="EmployeePF" /></h2>
                            <Trans i18nKey="benefitsPara1" ns="EmployeePF" />
                            <br /><br />
                            <Trans i18nKey="benefitsPara2" ns="EmployeePF" />
                            <h3><Trans i18nKey="benefitsCorpusHeader" ns="EmployeePF" /></h3>
                            <Trans i18nKey="benefitsCorpusPara" ns="EmployeePF" />
                            <h3><Trans i18nKey="benefitsLongTermHeader" ns="EmployeePF" /></h3>
                            <Trans i18nKey="benefitsLongTermPara" ns="EmployeePF" />
                            <h3><Trans i18nKey="benefitsTaxFreeHeader" ns="EmployeePF" /></h3>
                            <Trans
                                i18nKey="benefitsTaxFreePara1"
                                ns="EmployeePF"
                                components={[
                                    <strong key="0" />,
                                    <a
                                        key="1"
                                        href="https://www.goodreturns.in/section-80c-of-income-tax-act-s1.html"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ]}
                            />
                            <br /><br />
                            <Trans i18nKey="benefitsTaxFreePara2" ns="EmployeePF" />
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default EmployeePF;
